import { SearchState } from 'src/hooks/meilisearch/types/search-state';

export const issuesKeys = {
  all: ['issues'] as const,
  lists: () => [...issuesKeys.all, 'list'] as const,
  list: (
    directoryToken: string,
    page: number,
    perPage: number,
    searchState?: SearchState,
  ) =>
    [
      ...issuesKeys.lists(),
      directoryToken,
      { page, perPage, ...searchState },
    ] as const,
  details: () => [...issuesKeys.all, 'detail'] as const,
  detail: (token: string) => [...issuesKeys.details(), token] as const,
};
